import { FormControlLabel, Radio } from '@mui/material';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { usePromiseTracker } from 'react-promise-tracker';

export const ForfeitBonus = ({ disableNagativeOrVoid, isRadioButtonEditable }: { disableNagativeOrVoid: boolean; isRadioButtonEditable?: boolean }) => {
  const { control, setValue } = useFormContext();
  const isChecked = useWatch({ name: 'forfeitBonus' });
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disableNagativeOrVoid && !isSaveModApiCalling && isRadioButtonEditable !== false) {
      const newValue = !isChecked;
      setValue('bonusPaid', false, { shouldDirty: true });
      setValue('forfeitBonus', newValue, { shouldDirty: true });
    }
  };

  return (
    <Controller
      control={control}
      name={'forfeitBonus'}
      render={({ field: { onChange, value, ...rest } }) => {
        return (
          <FormControlLabel
            name={'forfeitBonus'}
            key={'Forfeit Bonus'}
            control={
              <Radio
                name="forfeitBonus"
                disabled={disableNagativeOrVoid || isSaveModApiCalling || isRadioButtonEditable === false}
                checked={isChecked}
                onClick={handleClick}
                onChange={() => {}}
                {...rest}
              />
            }
            label={'Forfeit Bonus'}
          />
        );
      }}
    />
  );
};
